import { makeRequest } from '../../../api/makeRequest';

export const getInvitedNumbers = () => makeRequest({
  url: '/customers/products/mobile/profile/invitedInformation/',
});
